import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EcitationSearchService {
  url = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getSearchResults(params: any) {
    return this.http.get(this.url + `/ecitation-services/citationsearch/?${params}`);
  }

  getPublicSearchResults(params: any) {
    return this.http.get(this.url + `/ecitation-services/publiccitationsearch/?${params}`);
  }

  getErrorDocResults(params: any) {
    return this.http.get(this.url + `/ecitation-services/errorsearch/${params}`);
  }

  async generateParams(params: any) {
    const queryParams: string[] = [];
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        if (Array.isArray(params[key])) {
          params[key].forEach((value: string | number | boolean) => {
            const encodeKey = encodeURIComponent(key);
            const encodedValue = encodeURIComponent(value.toString());
            queryParams.push(`${encodeKey}=${encodedValue}`);
          });
        } else {
          const encodeKey = encodeURIComponent(key);
          const encodedValue = encodeURIComponent(params[key]);
          queryParams.push(`${encodeKey}=${encodedValue}`);
        }
      }
    }
    return queryParams.join('&');
  }

  getAllAgencies() {
    return this.http.get(this.url + `/ecitation-services/allAgencies`);
  }

  purgeRecords(pData: any) {
    return this.http.post(this.url + `/ecitation-services/deleteCitation`, pData);
  }

  deleteErrorDoc(pData: any) {
    return this.http.post(this.url + `/ecitation-services/deleteErrorCitation?${pData}`, {});
  }

  resendCitation(pData: any) {
    return this.http.post(this.url + `/ecitation-services/resendCitation`, pData);
  }

  /**
   * Retrieve the raw XML for a given citation number as text.
   */
  getCitationXml(citationNumber: string): Observable<string> {
    const endpoint = `${this.url}/ecitation-services/citationxml/${encodeURIComponent(citationNumber)}`;
    const headers = new HttpHeaders({ 'Accept': 'application/xml' });
    return this.http.get(endpoint, { headers, responseType: 'text' });
  }
}
